<div class="right_col screen-height v_scrnss edit-page" role="main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 mb-4 ">
                <h1 class="text-left font-weight-bold text-uppercase text-dark">Users</h1>
            </div>
        </div>
        <ul class="nav nav-tabs mb-4">
            <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'all'" (click)="setTab('all')" style="cursor:pointer">All Users</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'duplicates'" (click)="setTab('duplicates')" style="cursor:pointer">Duplicate Accounts</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'ghosts'" (click)="setTab('ghosts')" style="cursor:pointer">Ghost Accounts</a>
            </li>
        </ul>

        <div class="row">
            <div class="col-md-12">
                <!-- All Users Tab -->
                <div class="card" [class.d-none]="activeTab !== 'all'">
                    <div class="mt-3 ml-4">
                        <h2 style="display: inline;" class=" mt-8 mr-2">{{subscribeLabel}}</h2>
                        <label class="switch mb-2">
                            <input type="checkbox" (click)="checked($event)" [checked]="checkedSubscribed">
                            <span class="slider round"></span>
                        </label>
                    </div>
                    <div class="card-body">
                        <table datatable [dtOptions]="dtOptions" class="table row-border hover mat-table" width="100%"
                            cellspacing="0" id="user-table">
                            <thead>
                                <tr>
                                    <th style="display: none;" class="th-heading"></th>
                                    <th class="th-heading">Name</th>
                                    <th class="th-heading">User ID</th>
                                    <th class="th-heading">Email</th>
                                    <th class="th-heading">Phone No.</th>
                                    <th class="th-heading">Account Created On</th>
                                    <th class="th-heading">Activation Status</th>
                                    <th class="th-heading">Action</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="rows?.length != 0">
                                <tr *ngFor="let user of rows">
                                    <td style="display: none;"></td>
                                    <td>{{user.name}}</td>
                                    <td>{{user._id}}</td>
                                    <td>{{user.email}}</td>
                                    <td>{{user.phone}}</td>
                                    <td>{{user.createdDate | date}}</td>

                                    <td>
                                        <label class="switch">
                                            <input type="checkbox" [checked]="user.userStatus == true"
                                                (click)="changeStatus(user._id, $event)">
                                            <span class="slider round"></span>
                                        </label>
                                    </td>
                                    <td><span class="flex_wrp flex_strt drec_colomn">
                                            <a> <button class="btn btn-outline-success user-glyf"
                                                    (click)="getUsersEditPage(user._id)">Edit</button></a>
                                            <a> <button class="btn btn-outline-info user-glyf"
                                                    (click)="getUsersDetailPage(user._id)">Details</button></a>
                                            <button class="btn btn-outline-danger user-glyf"
                                                (click)="deleteModelDiallog(user._id)">Remove</button>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="rows?.length == 0">
                                <tr>
                                    <td colspan="7" class="no-data-available">No data available in table!</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Duplicate Accounts Tab -->
                <div class="card" *ngIf="activeTab === 'duplicates'">
                    <div class="card-body">
                        <div *ngIf="duplicateAccounts.length === 0" class="text-center py-4 text-muted">No duplicate accounts found.</div>
                        <div class="accordion" id="duplicatesAccordion" *ngIf="duplicateAccounts.length > 0">
                            <div class="card mb-2" *ngFor="let group of duplicateAccounts; let i = index">
                                <div class="card-header bg-light d-flex justify-content-between align-items-center" (click)="toggleGroup(group._id)" style="cursor: pointer;">
                                    <h5 class="mb-0 font-weight-bold">
                                        {{ group._id | titlecase }} 
                                        <span class="badge badge-warning ml-2">{{ group.count }} Accounts</span>
                                    </h5>
                                    <i class="fa" [ngClass]="expandedGroups[group._id] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                </div>
                                <div class="collapse" [class.show]="expandedGroups[group._id]">
                                    <div class="card-body p-0">
                                        <table class="table table-striped m-0">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th>User ID</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Google ID</th>
                                                    <th>Apple ID</th>
                                                    <th>Created</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let user of group.users">
                                                    <td>{{ user.userId }}</td>
                                                    <td>{{ user.email || 'N/A' }}</td>
                                                    <td>{{ user.phone || 'N/A' }}</td>
                                                    <td>{{ user.googleId ? 'Yes' : 'No' }}</td>
                                                    <td>{{ user.appleId ? 'Yes' : 'No' }}</td>
                                                    <td>{{ user.createdAt | date }}</td>
                                                    <td>
                                                        <button class="btn btn-sm btn-outline-info mr-2" (click)="getUsersDetailPage(user.userId)">Details</button>
                                                        <button class="btn btn-sm btn-outline-danger" (click)="deleteModelDiallog(user.userId)">Remove</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Ghost Accounts Tab -->
                <div class="card" *ngIf="activeTab === 'ghosts'">
                    <div class="card-body">
                        <table class="table table-striped table-bordered w-100" *ngIf="ghostAccounts.length > 0">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>User ID</th>
                                    <th>Google ID</th>
                                    <th>Apple ID</th>
                                    <th>Created</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let user of ghostAccounts">
                                    <td>{{ user.name || 'Unknown' }}</td>
                                    <td>{{ user.userId }}</td>
                                    <td>{{ user.googleId || 'N/A' }}</td>
                                    <td>{{ user.appleId || 'N/A' }}</td>
                                    <td>{{ user.createdAt | date }}</td>
                                    <td>
                                        <button class="btn btn-sm btn-outline-info mr-2" (click)="getUsersDetailPage(user.userId)">Details</button>
                                        <button class="btn btn-sm btn-outline-danger" (click)="deleteModelDiallog(user.userId)">Remove</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="ghostAccounts.length === 0" class="text-center py-4 text-muted">No ghost accounts found.</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}" *ngIf="showDialog == 1">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <form>
                            <div>
                                <div class="text-center">
                                    <h2>Are you sure, you want to delete?</h2>
                                </div>

                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="col-sm-6">
                            <button type="button" class="btn btn-default smingl_button" (click)="closeModalDialog()"
                                style="border-color: #117a8b;">Cancel</button>
                        </div>
                        <div class="col-sm-6">
                            <div class="text-right">
                                <input type="submit" class="btn btn-danger btn-lg smingl_button" value="Delete"
                                    (click)="deleteUser(deleteId)">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>